export const useNav = () => useState<boolean>('useNav', () => false)
